import { render, staticRenderFns } from "./mybusiness.vue?vue&type=template&id=85649fae&scoped=true&"
import script from "./mybusiness.vue?vue&type=script&lang=js&"
export * from "./mybusiness.vue?vue&type=script&lang=js&"
import style0 from "./mybusiness.vue?vue&type=style&index=0&id=85649fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85649fae",
  null
  
)

export default component.exports